import { IsString, IsBoolean, IsDefined, IsIn, IsOptional } from 'class-validator';

const INPUT_TYPE_VALUES = ['consent'] as const;
const LINK_VARIANT_VALUES = ['link1', 'link2'] as const;

export class FormConsentFieldPropsDto {
  @IsOptional()
  @IsString()
  id?: string;

  @IsDefined()
  @IsIn([...INPUT_TYPE_VALUES])
  inputType!: (typeof INPUT_TYPE_VALUES)[number];

  @IsDefined()
  @IsString()
  label!: string;

  @IsDefined()
  @IsBoolean()
  required!: boolean;

  @IsDefined()
  @IsBoolean()
  hidden!: boolean;

  @IsDefined()
  @IsString()
  text!: string;

  @IsDefined()
  @IsBoolean()
  selectedByDefault!: boolean;

  @IsDefined()
  @IsBoolean()
  showDescription!: boolean;

  @IsDefined()
  @IsString()
  description!: string;

  @IsDefined()
  @IsBoolean()
  showUrlLink!: boolean;

  @IsDefined()
  @IsString()
  linkUrl!: string;

  @IsDefined()
  @IsString()
  linkText!: string;

  @IsDefined()
  @IsIn([...LINK_VARIANT_VALUES])
  selectedLinkVariant!: (typeof LINK_VARIANT_VALUES)[number];
}
